import React from 'react'
import { checkTranslation, chooseWallpaper, imageAddress, msToHMS, translate } from "../../../utils/useful";
import Responsive from '../../../components/Responsive';
import LoaderButton from '../../../components/LoaderButton';
import IntractionActionsList from '../../../components/IntractionActionsList';
import FixedView from '../../../components/FixedView';
import moment from 'jalali-moment';
import ButtonAnimated from '../../../components/buttons/ButtonAnimated';
import Modal from '../../../components/Modal';
import AnswerSheetForm from './AnswerSheetForm';


class EndQuiz extends React.Component {
    state = {
        // pages: [
        //     { key: 'dashboard', label: 'Dashboard', icon: '/assets/icons/fi-sr-apps.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        //     { key: 'rooms', label: 'Your Rooms', icon: '/assets/icons/fi-sr-info.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        //     { key: 'schedule', label: 'Schedule', icon: '/assets/icons/fi-sr-apps.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        //     { key: 'history', label: 'History', icon: '/assets/icons/fi-sr-megaphone.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        // ],

        quiz: {
            name: "Math class Exam",
            description1: "Sem ut elit, bibendum vitae felis, magna. Tristique interdum auctor eleifend egestas.",
            description2: "Sem ut elit, bibendum vitae felis, magna. Tristique interdum auctor eleifend egestas. Suscipit sit commodo, odio ...",
            teacher: "Mr.Brown",
            duration: "2 Hour",
            difficulty: "Hard",
            opening: "28 Nov",
            closing: "30 Nov",
        },

        result: "98",

        // currentPage: 'dashboard'
    }

    componentDidMount() {
        if (this.props.setHeader) {

            this.props.setHeader({
                'topHeaderComponent': this.topHeaderComponent,
                'showToolbar': false,
                'title': this.props.page?.title,
                'subtitle': this.props.page?.subtitle,
            })

        }
    }
    topHeaderComponent = () => {

        return (
            <div className='flexc'>
              

            </div>
        )
    }
    componentWillUnmount() {
    }


    retake = () => {
        this.props.retake()
        // this.props.changeStage('startQuiz')
    }
    goToQuiz = () => {
        // this.props.retake()
        this.props.changeStage('start')
    }
    showAnswerSheetAlert = () => {
        if (!this.props.current.values.cantRetake) {

            this.retakeAlertModal.showModal()
        } else {
            // this.answerSheetModal.showModal()
            this.props.viewAnswerSheet()

        }
    }
    showAnswerSheet = () => {
        this.props.answerSheetViewed()
        this.retakeAlertModal.hideModal()
        // this.answerSheetModal.showModal()
    }
    getTeacherName = (teacher) => {
        if (this.props.quiz.populates.users) {
            let userInfo
            this.props.quiz.populates.users.map((element) => {
                if (element._id == teacher) {
                    userInfo = element.fullname
                }
            })
            return userInfo
        }
    }
    render() {
        let quiz = this.state.quiz

        return (

            <div className='h-100 w-100 scroll-no-scrollbar' style={{ backgroundColor: '#f6f6f6' }}>
                {/* <div className='w-100 window-content-radius-top pb-0' style={{ height: '50px', zIndex: 12, background: 'linear-gradient(90deg, hsla(147, 99%, 29%, 1) 0%, hsla(147, 100%, 35%, 1) 100%)', position: 'sticky', top: 0 }}>
                    <div className='px-3 py-2 flexc' style={{}}>
                        <div className='flexcb w-100 ' style={{}}>
                            <div className='flexc'>
                                {(this.state.backbtn == true) &&
                                    <button className='flexc prd-4' onClick={() => this.backStage()}>
                                        <img className='reverse' src="/assets/icons/angle-right-white.svg" height={20} />
                                    </button>
                                }
                                <div className="flexc" style={{ position: 'sticky', top: 0 }}>
                                    <img onClick={() => this.props.goToHub()} className='flexc  cursor-pointer' src={imageAddress(this.props.applet?.hub?.image, 'profile', 'small')} width="34px" style={{ height: 34, objectFit: 'cover', borderRadius: 100 }} />
                                    <div>
                                        <div className='flexcb w-100 ' >
                                            <div className='mld-2 flexc'>
                                                <p className="m-0 text-normal text-semibold mb-0 white flexc" style={{ maxWidth: 450 }}>{checkTranslation(this.props.applet?.name)}
                                                    <span onClick={() => this.props.goToHub()} className='flexc mld-2  cursor-pointer' >
                                                        <span className="mt-0 text-smaller  white opacity-7" >/ {this.props.applet?.hub?.fullname}</span>
                                                    </span>
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flexc">

                                <button className='px-1 flexc' style={{ cursor: 'pointer' }} onClick={() => { this.ViewsIntractionActions?.filterFixedView?.filterEditor.open() }} >
                                    <img width={24} src='/assets/icons/applets/database/search-white.svg' />
                                </button>

                                <button className='px-1 flexc position-relative' style={{ cursor: 'pointer' }} ref={el => this.notification = el} onClick={() => { this.notificationView.showView() }} >
                                    <img width={24} src='/assets/icons/applets/database/notification-white.svg' />
                                    <div className="position-absolute px-1 flexcc" style={{ zIndex: 1, background: '#FF3B30', color: '#fff', borderRadius: 20, top: -5, left: 15, height: 16, minWidth: 16 }}>
                                        <p className="text-smaller">2</p>
                                    </div>
                                </button>


                                <button className='pld-2 flexc' ref={el => this.settingsBut = el} style={{ cursor: 'pointer' }} onClick={() => { this.settingsView.showView() }} >
                                    <img width={24} src='/assets/icons/applets/database/setting-white.svg' />
                                </button>


                                <FixedView width={this.props.width} zIndex={10} ref={el => this.settingsView = el} nodeRef={this.settingsBut} xOffset={160} bottomOffset={25} topOffset={5} maxWidth={200} >
                                    <div className='bg-white br-10 p-2 shadow-3'>
                                        <div className='mb-2'>
                                            <IntractionActionsList data={{ title: "{{lang}}Stages", icon: "/assets/icons/applets/database/stages-purple.svg" }} />
                                            <IntractionActionsList data={{ title: "{{lang}}Actions", icon: "/assets/icons/applets/database/bolt-purle.svg" }} />
                                            <IntractionActionsList data={{ title: "{{lang}}Automations", icon: "/assets/icons/applets/database/automation-purple.svg" }} />
                                            <IntractionActionsList data={{ title: "{{lang}}Permissions", icon: "/assets/icons/applets/database/key-purple.svg" }} />
                                        </div>
                                        <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                            <IntractionActionsList data={{ title: "{{lang}}Open Settings", icon: "/assets/icons/applets/database/setting-purple.svg" }} />
                                        </div>
                                    </div>
                                </FixedView>
                            </div>
                        </div>
                    </div>
                </div > */}

                <div className='p-5 br-10' style={{ backgroundColor: '#fff', boxShadow: '#03a4461e 0px 0px 20px' }}>
                    <div className=' modern-input1 with-shadow px-3 py-4 cursor-pointer' style={{}}>
                        <div className='flexcc flex-column w-100'>
                            <div className=''>
                                {this.props.quiz?.values?.autoCorrection ? (

                                    <div className='flexcc mt-4' style={{ width: '150px', height: '150px', borderRadius: '100px', backgroundColor: 'rgb(1, 149, 68,0.6)' }}>
                                        <div className="flexcc" style={{ position: 'relative' }}>
                                            <img style={{}} src='/assets/icons/hexagon.svg' width={100} />
                                            <p className='weight-500 font-size-20' style={{ position: 'absolute', top: 36, color: '#fff' }}>{(((this.props.current?.values?.score)))}/100</p>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='flexcc mt-4 w-100 h-100'  >
                                        <div className="flexcc" style={{ position: 'relative' }}>
                                            <p className='weight-500 font-size-16' style={{ color: '#909090' }}>{translate('Your score would be ready after correction')}</p>

                                        </div>
                                    </div>


                                )}
                            </div>
                            <div className='d-flex flex-column pt-5 pld-5'>
                                <div className='d-flex flexc'>
                                    <div className="position-relative d-flex mb-2">
                                        <img className="mt-1" src={this.props.applet?.image ? imageAddress(this.props.applet?.image) : ('/assets/icons/applets/' + ((this.props.applet?.features && this.props.applet?.features[0]) ? String(this.props.applet?.features[0]).toLowerCase() : String(this.props.applet?.type).toLowerCase()) + ".png")} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                                    </div>
                                    <h2 className="pld-3 font-size-18 mb-0" >{checkTranslation(this.props.quiz?.values?.title)}</h2>
                                </div>
                                <div className='d-flex w-100 pb-3 pt-2 px-3 cursor-pointer'>
                                    <div className='d-flex flex-column w-100'>
                                        <div className='pt-3 pb-2 flexcb '>
                                            <p className='weight-500'>{translate('Teacher')}</p>
                                            <p className='color-gray-3 weight-200'>{this.getTeacherName(this.props.quiz?.values?.teacher)}</p>
                                        </div>

                                        {this.props.quiz?.values?.duration && (

                                            <div className='pt-3 pb-2 flexcb '>
                                                <p className='weight-500'>{translate('Duration')}</p>
                                                {/* <p className='color-gray-3 weight-200'>{msToHMS(this.props.quiz?.values?.duration)}</p> */}
                                                <p className='color-gray-3 weight-200'>{((this.props.quiz?.values?.duration[0] ?? '00') + ':' + (this.props.quiz?.values?.duration[1] ?? '00') + ':' + (this.props.quiz?.values?.duration[2] ?? '00'))}</p>
                                            </div>
                                        )}
                                        <div className='pt-3 pb-2 flexcb '>
                                            <p className='weight-500'>{translate('Opening Time')}</p>
                                            <p className='color-gray-3 weight-200'>{moment(this.props.quiz?.values?.date).format("DD,  MMM, YYYY (HH:mm)")}</p>
                                        </div>
                                        <div className='pt-3 pb-2 flexcb '>
                                            <p className='weight-500'>{translate('Closing Time')}</p>
                                            <p className='color-gray-3 weight-200'>{moment(this.props.quiz?.values?.expiryDate).format("DD,  MMM, YYYY (HH:mm)")}</p>
                                        </div>
                                        {this.props.quiz?.values?.seeAnswer && this.props.current?.values?.answerSheet && (

                                            <button className='green-box-h br-5 py-2 mt-3' style={{ boxShadow: '#03a4461e 0px 0px 15px' }} onClick={() => { this.showAnswerSheetAlert() }}>
                                                <p className='weight-500 font-size-14'>{translate('Answer Sheet')}</p>
                                            </button>
                                        )}
                                        {!this.props.current.values?.cantRetake && this.props.quiz?.values?.retakeNumber > 0 && (this.props.quiz?.values?.retakeNumber> this.props.allQuizes?.length)&&  (moment(new Date()).valueOf() < moment(this.props.quiz?.values?.expiryDate).valueOf() || !this.props.quiz?.values?.expiryDate) ? (



                                            <button className='gray-box-border br-5 py-2 mt-3' onClick={() => { this.retake() }}>
                                                <p className='weight-500 font-size-14'>{translate('Retake Quiz')}</p>
                                            </button>
                                        ) : (
                                            <button className='gray-box-border br-5 py-2 mt-3' onClick={() => { this.goToQuiz() }}>
                                                <p className='weight-500 font-size-14'>{translate('Go To My Quizes')}</p>
                                            </button>

                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal ref={el => this.answerSheetModal = el} maxWidth={600}>
                    <div className="w-100 br-10 p-3" style={{ backgroundColor: "white" }} >
                        {/* <div className="flexcc">
                        <img width={200} src="/assets/icons/svgs/endexam.svg" />
                    </div> */}
                        <div className="w-100 flexcc">
                            <p className="py-2 font-size-16 weight-500" style={{ color: '#222' }}>{translate('Answer sheet')}</p>
                        </div>
                        <AnswerSheetForm ref={el => this.form = el} disabled={true} initData={this.props.current?.values.answerSheet} data={this.props.current?.values.answerSheet} scoreData={this.props.current?.values.scoresSheet} headers={this.props.quiz?.values?.questions} questions={this.props.quiz?.values?.questions} inputClass={'modern-input'} nopadding={true} hasScore={this.props.current?.values.scoresSheet ? true : false} disableInputs={true} />
                        <div className="flexcc pt-3 pb-1" style={{}}>
                            <div className="mrd-1">
                                <ButtonAnimated
                                    // icon={'/assets/icons/arrow-right-white.svg'}
                                    bg={'rgba(120, 120, 120, 0.1)'}
                                    title={translate('Close')}
                                    textColor={'rgba(120, 120, 120)'}
                                    onClick={() => this.answerSheetModal.hideModal()}
                                />
                            </div>


                        </div>
                    </div>
                </Modal>
                <Modal ref={el => this.retakeAlertModal = el} maxWidth={400}>
                    <div className="w-100 br-10 p-3" style={{ backgroundColor: "white" }} >
                        {/* <div className="flexcc">
                        <img width={200} src="/assets/icons/svgs/endexam.svg" />
                    </div> */}
                        <div className="w-100 flexcc">
                            <p className="py-2 font-size-16 weight-500" style={{ color: '#222' }}>{translate('If you see the answer sheet you will not be able to retake the exam!')}</p>
                        </div>
                        <div className="flexcc pt-3 pb-1" style={{}}>
                            <div className="mrd-1">
                                <ButtonAnimated
                                    // icon={'/assets/icons/arrow-right-white.svg'}
                                    bg={'rgba(120, 120, 120, 0.1)'}
                                    title={translate('Cancel')}
                                    textColor={'rgba(120, 120, 120)'}
                                    onClick={() => this.retakeAlertModal.hideModal()}
                                />
                            </div>
                            <div className="mld-1">
                                <ButtonAnimated
                                    icon={'/assets/icons/arrow-right-white.svg'}
                                    bg={this.props.colors ? this.props.colors.background : 'linear-gradient(90deg, #6E9318, #96C723)'}
                                    title={translate('Show')}
                                    textColor={this.props.colors ? this.props.colors.textColor : '#fff'}
                                    onClick={() => this.showAnswerSheet()}
                                />
                            </div>
                            {/* <button className="modalCancelButton mrd-1" onClick={() => this.modal.hideModal()}>
                            {translate('Cancel')}
                        </button>
                        <button className='modalEndQuizButton mld-1' onClick={() => this.endInqury()}>
                            {translate('End')}
                        </button> */}
                        </div>
                    </div>
                </Modal>
            </div >
        )
    }
}

export default EndQuiz;